var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#fff;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,0h0a50,50,0,0,1,50,50h0a50,50,0,0,1-50,50h0A50,50,0,0,1,0,50H0A50,50,0,0,1,50,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,2.5h0A47.5,47.5,0,0,1,97.5,50h0A47.5,47.5,0,0,1,50,97.5h0A47.5,47.5,0,0,1,2.5,50h0A47.5,47.5,0,0,1,50,2.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-3",
    d: "M85,42.36A15.24,15.24,0,0,0,69.76,27.12H30.26A15.24,15.24,0,0,0,15,42.36v18.5A15.24,15.24,0,0,0,30.26,76.1h39.5A15.24,15.24,0,0,0,85,60.86ZM60.07,52.55,44.31,61.2c-.69.37-1.31-.13-1.31-.91V42.55c0-.79.64-1.29,1.32-.9l15.87,9.1a1,1,0,0,1,.32,1.43,1,1,0,0,1-.43.37Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c437c9103d0d0ea267b1e5757cb6bafd.svg";
export { ForwardRef as ReactComponent };